"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultRoom = void 0;
const getDefaultRoom = () => ({
    id: "",
    text: "",
    originalHref: "",
    originalScheduleURI: "",
    labels: [],
});
exports.getDefaultRoom = getDefaultRoom;
//# sourceMappingURL=Room.js.map